module.exports = __webpack_public_path__ + "static/media/ic_on_a_mission_green.3d643019.svg";